<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Banka</label>
            <v-select-list :options="banks" v-model="bank" placeholder="Banka" label="Name"></v-select-list>
        </div>
        <div class="col-12 mt-1">
            <label class="form-label">Kampanya</label>
            <input class="form-control" v-model="value.Campaign" placeholder="Kampanya"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        banks:Array
    },
    computed:{
        bank:{
            get:function(){
                return this.banks.find(r=>r.Value == this.value.Bank)
            },
            set:function(value){
                this.value.Bank = value?.Value != "undefined" ? value.Value : null
            }
        },
    }
}
</script>

<style>

</style>